<style scoped lang="scss">
.alert {
    margin-top: 12px;
}
</style>

<template>
    <div class="container">
        <b-row class="justify-content-center">
            <b-col lg="4" md="6">
                <p class="lead text-center text-uppercase mb-1">Welcome</p>

                <b-alert
                    v-for="(error, key) in errors.non_field_errors"
                    :key="key" variant="danger"
                    show
                    dismissible>
                    {{ error }}
                </b-alert>

                <b-alert
                    v-if="$route.query.message"
                    :variant="$route.query.alert_type"
                    show
                    dismissible
                >
                    {{$route.query.message}}
                </b-alert>
                <b-form v-on:submit.prevent="submit()">
                    <p class="text-muted text-center">Log in to your account</p>
                    <b-input-group class="mb-3">
                        <b-input-group-prepend>
                            <b-input-group-text>
                                <i class="fa fa-user"></i>
                            </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                            v-model="user.email"
                            :class="{
                                'is-invalid': this.errors.email
                            }"
                            type="text"
                            class="form-control"
                            placeholder="Email"
                            autocapitalize="none"
                            autocomplete="email" />
                        <div v-if="this.errors.email && this.errors.email.length" class="invalid-feedback">
                            {{ this.errors.email[0] }}
                        </div>
                    </b-input-group>
                    <b-input-group class="mb-4">
                        <b-input-group-prepend>
                            <b-input-group-text><i class="fa fa-lock"></i></b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input
                            v-model="user.password"
                            :class="{
                                'is-invalid': this.errors.password
                            }"
                            type="password"
                            class="form-control"
                            placeholder="password"
                            autocapitalize="none"
                            autocomplete="current-password" />
                    </b-input-group>
                    <b-row>
                        <b-col cols="12">
                            <b-button
                                block
                                type="submit"
                                variant="primary"
                                :disabled="!(user.email && user.password) || loginPending">
                                <i
                                    v-if="loginPending"
                                    class="fa fa-refresh fa-spin">
                                </i>
                                Login
                            </b-button>
                        </b-col>
                    </b-row>
                </b-form>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'Login',
    data: () => {
        return {
            user: {
                email: '',
                password: '',
            },
            errors: {},
            loginPending: false,
        };
    },
    created: function() {
        if (this.isAuthenticated) {
            const redirect = this.$route.query.redirect || '/';
            this.$router.push(redirect);
        }
    },
    computed: {
        // mix the getters into computed with object spread operator
        ...mapGetters({
            isAuthenticated: 'auth/isAuthenticated',
        }),
    },
    methods: {
        ...mapActions({
            login: 'auth/login',
        }),
        submit() {
            this.errors = {};
            this.loginPending = true;
            this.login(this.user)
                .then(() => {
                    const redirect = this.$route.query.redirect || '/';
                    this.$router.push(redirect);
                })
                .catch(err => {
                    this.loginPending = false;
                    if (err) {
                        this.errors = err.data;
                    }
                });
        },
    },
};
</script>
